import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from './rootReducer';
import {
  MainConfigChartsData,
  LinkedConfigChartsData,
} from '../components/AstronautDataExplorer/AstronautFilterMenu/types';

export type DataConfigChartInitialState = {
  configChartsData: MainConfigChartsData;
  configLinkedChartsData: LinkedConfigChartsData;
  isDataChartConfigError: boolean;
  errorMessage: string;
};

export const dataConfigChartInitialState: DataConfigChartInitialState = {
  configChartsData: {
    externalId: '',
    configurations: [],
  },
  configLinkedChartsData: {
    configurations: [],
    entityName: '',
    externalId: '',
    linkedName: '',
  },
  isDataChartConfigError: false,
  errorMessage: '',
};

export const dataConfigChartSlice = createSlice({
  name: 'dataConfigCharts',
  initialState: dataConfigChartInitialState,
  reducers: {
    getChartsConfigurationSuccess: (
      state,
      action: PayloadAction<MainConfigChartsData>,
    ) => {
      state.configChartsData = action.payload;
      state.isDataChartConfigError = false;
      state.errorMessage = '';
    },
    getChartsLinkedConfigurationSuccess: (
      state,
      action: PayloadAction<LinkedConfigChartsData>,
    ) => {
      state.configLinkedChartsData = action.payload;
      state.isDataChartConfigError = false;
      state.errorMessage = '';
    },
    setChartsConfigurationError: (state, action: PayloadAction<string>) => {
      state.configChartsData = {
        externalId: '',
        configurations: [],
      };
      state.isDataChartConfigError = true;
      state.errorMessage = action.payload;
    },
  },
});

export const getDataChartConfigFile = createAction<{
  entityId: string | undefined;
}>('GET_CHARTS_CONFIGURATION_REQUEST');

export const {
  getChartsConfigurationSuccess,
  getChartsLinkedConfigurationSuccess,
  setChartsConfigurationError,
} = dataConfigChartSlice.actions;

export const dataConfigChartSelectors = {
  selectConfigChartsData: (state: RootState) =>
    state.dataConfigCharts.configChartsData.configurations,
  selectConfigLinkedChartsData: (state: RootState) =>
    state.dataConfigCharts.configLinkedChartsData,
  selectConfigError: (state: RootState) =>
    state.dataConfigCharts.isDataChartConfigError,
  selectConfigErrorMessage: (state: RootState) =>
    state.dataConfigCharts.errorMessage,
};

export default dataConfigChartSlice.reducer;
